export default __webpack_public_path__ + "static/media/react.2c75e5d4.png";